import request from '@/utils/request'


/**
 * 试题列表
 * @param query
 */
export function fetchList(param) {
    return request({
        url: '/api/question/list/' + param,
        method: 'post'
    })
}


/**
 * 删除试题
 * @param param
 */
export function remove(param) {
    return request({
        url: '/api/question/delete/' + param,
        method: 'get'
    })
}

/**
 * 获取单个试题信息
 * @param param
 */
export function getQuestion(param) {
    return request({
        url: '/api/question/get/' + param,
        method: 'get'
    })
}

/**
 * 保存试题
 * @param param
 */
export function save(param) {
    return request({
        url: '/api/question/save',
        method: 'post',
        data: param
    })
}

/**
 * 修改试题
 * @param param
 */
export function update(param) {
    return request({
        url: '/api/question/update',
        method: 'post',
        data: param
    })
}

